import { CS_LANG } from "./cs";
import { EN_LANG } from "./en";
import { SK_LANG } from "./sk";

export const LANGUAGES = {
    cs : CS_LANG,
    sk : SK_LANG,
    en : EN_LANG,
};
